module.exports = __webpack_public_path__ + "static/media/MissionPic.30290ef6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/MissionPic.jpg
// module id = 52
// module chunks = 0